export const FETCH_ALERT_DEVICES = 'FETCH_ALERT_DEVICES';
export const FETCH_ACCOUNT_SERVICES = 'FETCH_ACCOUNT_SERVICES';
export const FETCH_ALERT_DEVICES_EVENTS = 'FETCH_ALERT_DEVICES_EVENTS';
export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_EVENTS_DEVICES = 'FETCH_EVENTS_DEVICES';
export const FETCH_CLIENTS_ACCOUNTS = 'FETCH_CLIENTS_ACCOUNTS';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
